import { useAppSelector } from '../../store/hooks';
import { useGetPipelinesQuery } from '../../store/data/dataSlice';
import { Pipeline } from '../../store/data/types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

const useGetPipelinesByEmail = (): {
  data: Pipeline[] | undefined;
  error: FetchBaseQueryError | SerializedError | undefined;
  isLoading: boolean;
} => {
  //const email = useAppSelector(store => store.usertoken.token);
//  console.log(store.user.profile?.email)
  const { data, isLoading, error } = useGetPipelinesQuery();
  return { data, isLoading, error };
};

export default useGetPipelinesByEmail;
